import React from "react"
import ReactDOM from "react-dom"
import NewsContainer from "./news-container-component"

export default class NewsContainerModule {
  constructor(elem) {
    const self = this
    self.elem = elem
    self.modelJson = elem.dataset.modelJson && JSON.parse(elem.dataset.modelJson)
    this.init()
    return self
  }

  init() {
    const self = this
    ReactDOM.unmountComponentAtNode(self.elem)
    ReactDOM.render(<NewsContainer {...self.modelJson} />, self.elem)
  }
}
